var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6922",
    "data-name": "Group 6922",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.979,
    height: 15.979,
    viewBox: "0 0 15.979 15.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8021",
    "data-name": "Path 8021",
    d: "M0,0H15.979V15.979H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8022",
    "data-name": "Path 8022",
    d: "M5,10.329l3.329,3.329L14.987,7",
    transform: "translate(-1.671 -2.34)",
    fill: "none",
    stroke: "#32bf8f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.0cb5c5fa942eee8f5f4fe20d2b0a96a7.svg";
export { ForwardRef as ReactComponent };